@if (
  params?.colDef?.headerName === "Action" ||
  (params?.colDef?.headerName === "View Updates" &&
    loggedInUser.role.value !== "scw_supplier_user")
) {
  <span
    class="icon-jump-out grid-renderer-visibility-icon"
    title="Summary"
    (click)="redirectToSummaryLink(params.data.case_link)"
  >
  </span>
}
@if (
  params?.colDef?.headerName === "Action" ||
  params?.colDef?.headerName === "View Updates"
) {
  <span
    class="icon-eye grid-renderer-visibility-icon"
    title="View History"
    (click)="onSelectIncidentId()"
  >
  </span>
}

@if (
  params?.colDef?.headerName === "Case Number" &&
  loggedInUser.role.value !== "scw_supplier_user"
) {
  <span (click)="redirectToEsp(params.value)">
    <a target="_blank" class="grid-renderer-anchor">{{ params.value }} </a>
  </span>
}

@if (
  params?.colDef?.headerName === "Case Number" &&
  loggedInUser.role.value === "scw_supplier_user"
) {
  <span>
    {{ params.value }}
  </span>
}
